export default __webpack_public_path__ + "static/psql-95b42b54b2acd7a1ddfe9f2b140d8da6.svg";